
import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SingleDocumentUploadProps {
  id: string;
  label: string;
  accept?: string;
  currentFile?: string | null;
  onUpload: (file: File) => void;
}

export function SingleDocumentUpload({
  id,
  label,
  accept = '.pdf,.doc,.docx,.xlsx,.csv',
  currentFile,
  onUpload,
}: SingleDocumentUploadProps) {
  const [selectedFileName, setSelectedFileName] = useState<string>('');

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="file"
        accept={accept}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            setSelectedFileName(file.name);
            onUpload(file);
          }
        }}
        className="cursor-pointer"
      />
      {currentFile && (
        <div className="flex items-center gap-2">
          <a
            href={currentFile}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-blue-600 hover:underline"
          >
            View uploaded file
          </a>
        </div>
      )}
    </div>
  );
}
